<template>
    <div>
        <div class="filters-container">
            <div v-if="local_array_stocks_filters.length != 0" class="mobile-filter-grid">

                
                <div class="row-one-mobile">
                    <MobileFilterField title="Rentabilidad específica" :summary="rangeSummary(0)" :permitted="!!_g_UserFeatures.permissions.specific_rentability_filter">
                        <div v-if="_g_UserFeatures.permissions.specific_rentability_filter">
                            <SelectOutline v-for="(iSelect, selectIndex) in third_config[0].componentsConfig" :key="selectIndex" :options="iSelect.options" :helper_select_permission="iSelect.helper_select_permission" :default_value="local_array_stocks_filters[selectIndex].value" :helper_text_select="iSelect.helper_text_select" :component_class="iSelect.component_class" @_emit_method_order_select="_getValueFromSelect" class="inlined second-mobile-select" />
                        </div>
                        <div v-else>
                            <FilterNoPermission
                                :link="buy_link"
                            ></FilterNoPermission>
                            
                        </div>
                    </MobileFilterField>

                    <MobileFilterField v-if="!isBasicUser" title="Número de onda" :summary="rangeSummary(2)" :permitted="!!_g_UserFeatures.permissions.wave_number_filter">
                        <div v-if="_g_UserFeatures.permissions.wave_number_filter">
                            <SelectOutline v-for="(iSelect, selectIndex) in third_config[1].componentsConfig" :key="selectIndex" :options="iSelect.options" :helper_select_permission="iSelect.helper_select_permission" :default_value="local_array_stocks_filters[selectIndex+2].value" :helper_text_select="iSelect.helper_text_select" :component_class="iSelect.component_class" @_emit_method_order_select="_getValueFromSelect" class="inlined second-mobile-select" />
                        </div>
                        <div v-else>
                            <FilterNoPermission
                                :link="buy_link"
                            ></FilterNoPermission>
                            
                        </div>

                    </MobileFilterField>


                    <MobileFilterField title="Fecha de soporte" :summary="filterDateRange(datepicker_soporte_inferior, datepicker_soporte_superior)" :permitted="!!_g_UserFeatures.permissions.soport_date_filter">
                        <div v-if="_g_UserFeatures.permissions.soport_date_filter">
                            <label class="mobile-date-field"><span>Desde</span>
                            <Datepicker placeholder="dd/mm/aaaa" v-model="datepicker_soporte_inferior" :language="es" :full-month-name="true" :mondayFirst="true" :clearButton="true" format="dd/MM/yyyy" input-class="datepicker-input" class="inlined datepick" />
                            </label>
                            <label class="mobile-date-field"><span>Hasta</span>
                            <Datepicker placeholder="dd/mm/aaaa" v-model="datepicker_soporte_superior" :language="es" :full-month-name="true" :mondayFirst="true" :clearButton="true" format="dd/MM/yyyy" input-class="datepicker-input" class="inlined datepick" />
                            </label>
                        </div>
                        <div v-else>
                            <FilterNoPermission
                                :link="buy_link"
                            ></FilterNoPermission>
                            
                        </div>

                    </MobileFilterField>
                </div>
                <div class="row-two-mobile">
                    <MobileFilterField v-if="!isBasicUser" title="Fecha para estabilizar" :summary="filterDateRange(datepicker_estabilizar_inferior, datepicker_estabilizar_superior)" :permitted="!!_g_UserFeatures.permissions.wave_stabilizer">
                        <div v-if="_g_UserFeatures.permissions.wave_stabilizer">
                            <label class="mobile-date-field"><span>Desde</span>
                            <Datepicker placeholder="dd/mm/aaaa" v-model="datepicker_estabilizar_inferior" :language="es" :full-month-name="true" :mondayFirst="true" :clearButton="true" format="dd/MM/yyyy" input-class="datepicker-input" class="inlined datepicker-third-finder datepick" />
                            </label>
                            <label class="mobile-date-field"><span>Hasta</span>
                            <Datepicker placeholder="dd/mm/aaaa" v-model="datepicker_estabilizar_superior" :language="es" :full-month-name="true" :mondayFirst="true" :clearButton="true" format="dd/MM/yyyy" input-class="datepicker-input" class="inlined datepick" />
                            </label>
                        </div>
                        <div v-else>
                            <FilterNoPermission
                                :link="buy_link"
                            ></FilterNoPermission>
                            
                        </div>

                    </MobileFilterField>

                    <MobileFilterField v-if="!isBasicUser" title="Fecha en máximo histórico" :summary="filterDateRange(datepicker_maxHistorico_inferior, datepicker_maxHistorico_superior)" :permitted="!!_g_UserFeatures.permissions.historical_highs_dates_filter">
                        <div v-if="_g_UserFeatures.permissions.historical_highs_dates_filter">
                            <label class="mobile-date-field"><span>Desde</span>
                            <Datepicker placeholder="dd/mm/aaaa" v-model="datepicker_maxHistorico_inferior" :language="es" :full-month-name="true" :mondayFirst="true" :clearButton="true" format="dd/MM/yyyy" input-class="datepicker-input" class="inlined datepick" />
                            </label>
                            <label class="mobile-date-field"><span>Hasta</span>
                            <Datepicker placeholder="dd/mm/aaaa" v-model="datepicker_maxHistorico_superior" :language="es" :full-month-name="true" :mondayFirst="true" :clearButton="true" format="dd/MM/yyyy" input-class="datepicker-input" class="inlined datepick" />
                            </label>
                        </div>
                        <div v-else>
                            <FilterNoPermission
                                :link="buy_link"
                            ></FilterNoPermission>
                            
                        </div>

                    </MobileFilterField>
                    <MobileFilterField v-if="crypto_enabled==false && !isBasicUser" title="CFDs habilitados" :summary="local_array_stocks_filters[4].value" :permitted="!!_g_UserFeatures.permissions.CFDs_enabled">
                        <div v-if="_g_UserFeatures.permissions.CFDs_enabled">
                            <SelectInputFiltersNoNotch v-for="(iSelect, selectIndex) in third_config[5].componentsConfig" :key="selectIndex" :options="iSelect.options" :helper_select_permission="iSelect.helper_select_permission" :default_value="local_array_stocks_filters[selectIndex+4].value" :helper_text_select="iSelect.helper_text_select" :component_class="iSelect.component_class" @_emit_method_order_select="_getValueFromSelect" class="inlined" />
                        </div>
                        <div v-else>
                            <FilterNoPermission
                                :link="buy_link"
                            ></FilterNoPermission>
                            
                        </div>
                    </MobileFilterField>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ThirdConfig from "@/features/stockchart/components/Finder/configs/Third.json";
import MobileFilterField from './MobileFilterField.vue';
import { selectedFilterLabels, compactFilterList, filterDateRange, parseFilterDate } from './mobileFilterSummary';
import ThirdConfigCripto from "@/features/stockchart/components/Finder/configs/Third_cripto.json";
import SelectOutline from './MobileFilterSelect.vue';
import SelectInputFiltersNoNotch from './MobileFilterSelect.vue';
//import SelectOutlineDisabled from "@/shared/components/ui/SelectOutline_disabled";
import Datepicker from 'vuejs-datepicker';
import {en, es} from 'vuejs-datepicker/dist/locale'
import { mapMutations, mapGetters } from "vuex";
import APICaller from "@/shared/mixins/APICaller.js";
import FilterNoPermission from "@/features/stockchart/components/Finder/FilterNoPermission";


export default {
    mixins: [APICaller],
    name: 'Third_mobile',
    components: {
        MobileFilterField,
        SelectOutline,
        SelectInputFiltersNoNotch,
        //SelectOutlineDisabled,
        Datepicker,
        FilterNoPermission
    },
    props: {
        filters_user_json:{type: Object},
        recargar:{type: Boolean},
    },
    data: () => ({
        third_config: ThirdConfig,
        third_config_cripto: ThirdConfigCripto,
        local_array_stocks_filters: [],
        local_array_stocks_filters_default: [],
        local_array_criptos_filters: [],
        local_array_criptos_filters_default: [],
        en: en,
        es: es,
        finder:"",
        finder_original:"",

        datepicker_soporte_inferior: "",
        datepicker_soporte_superior: "",
        datepicker_estabilizar_inferior:"",
        datepicker_estabilizar_superior:"",
        datepicker_maxHistorico_inferior:"",
        datepicker_maxHistorico_superior:"",

        datepicker_soporte_inferior_cripto: "",
        datepicker_soporte_superior_cripto: "",
        datepicker_estabilizar_inferior_cripto:"",
        datepicker_estabilizar_superior_cripto:"",
        datepicker_maxHistorico_inferior_cripto:"",
        datepicker_maxHistorico_superior_cripto:"",

        rentabilidad_especifica_permission:"",
        numero_de_onda_permission:"",
        cfd_permission:"",
        fecha_de_soporte_permission:"",
        fecha_para_estabilizar_permission:"",
        fecha_maximo_historico_permission:"",
        permissions_loaded: false,
        buy_link: ""
    }),
    mounted() {
        this.buy_link = this.$detectEnvironment() + '/app/store';
    },
    created: function() {   
        var created_interval = setInterval(() => {
            if (this.filters_user_json != "") {
                this._getFinderParameters();
                clearInterval(created_interval);
            }
        }, 200);     
    },

    watch: {

        datepicker_soporte_inferior:{
            handler: function(newVal, oldVal){
                if (newVal != 'undefined//undefined') {
                    if(newVal == null) {
                        this.datepicker_soporte_inferior = "";
                    }
                    this._parseDatepickerFormat(this.datepicker_soporte_inferior.toString(), "soporteInferior")
                }
            },
            deep: true
        },

        datepicker_soporte_superior:{
            handler: function(newVal, oldVal){
                if (newVal != 'undefined//undefined') {
                    if(newVal == null) {
                        this.datepicker_soporte_superior = "";
                    }
                    this._parseDatepickerFormat(this.datepicker_soporte_superior.toString(), "soporteSuperior")
                }
            },
            deep: true
        },

        datepicker_estabilizar_inferior:{
            handler: function(newVal, oldVal){
                if (newVal != 'undefined//undefined') {
                    if(newVal == null) {
                        this.datepicker_estabilizar_inferior = "";
                    }
                    this._parseDatepickerFormat(this.datepicker_estabilizar_inferior.toString(), "estabilizarInferior")
                }
            },
            deep: true
        },

        datepicker_estabilizar_superior:{
            handler: function(newVal, oldVal){
                if (newVal != 'undefined//undefined') { 
                    if(newVal == null) {
                        this.datepicker_estabilizar_superior = "";
                    }
                    this._parseDatepickerFormat(this.datepicker_estabilizar_superior.toString(), "estabilizarSuperior")
                }
            },
            deep: true
        },

        datepicker_maxHistorico_inferior:{
            handler: function(newVal, oldVal){
                if (newVal != 'undefined//undefined') {
                    if(newVal == null) {
                        this.datepicker_maxHistorico_inferior = "";
                    }
                    this._parseDatepickerFormat(this.datepicker_maxHistorico_inferior.toString(), "maxHistoricoInferior")
                }
            },
            deep: true
        },

        datepicker_maxHistorico_superior:{
            handler: function(newVal, oldVal){
                if (newVal != 'undefined//undefined') {
                    if(newVal == null) {
                        this.datepicker_maxHistorico_superior = "";
                    }
                    this._parseDatepickerFormat(this.datepicker_maxHistorico_superior.toString(),"maxHistoricoSuperior")
                }
            },
            deep: true
        },

    },

    computed: {
        ...mapGetters(['_g_ArrayFiltersStocks', '_g_ArrayFiltersStocksDefault', '_g_ArrayFiltersCriptos', '_g_ArrayFiltersCriptosDefault', '_g_UserFeatures']),
        ...mapGetters({crypto_enabled:'_g_crypto_enable'}),
        ...mapGetters(["_g_User"]),
        isBasicUser() {
            return !!(this._g_User && (this._g_User.roles[21] || this._g_User.roles[20]));
        },
    },
    methods: {
        selectedFilterLabels, compactFilterList, filterDateRange,
        rangeSummary(offset) { return this.local_array_stocks_filters.slice(offset, offset + 2).map(item => item.value).join(' – '); },
        ...mapGetters(['_g_FinderFilters']),
        ...mapMutations(['setFinderFilters']),
        _parseFromFinderToDate() {
            const fields = [
                ['datepicker_soporte', this.finder.min_support_date, this.finder.max_support_date],
                ['datepicker_estabilizar', ...this.finder.profit_date],
                ['datepicker_maxHistorico', ...this.finder.max_min_bar_date]
            ];
            fields.forEach(([key, from, to]) => {
                this[key + '_inferior'] = parseFilterDate(from);
                this[key + '_superior'] = parseFilterDate(to);
            });
        },
        _parseDatepickerFormat(value, field) {
            const date = value ? new Date(value) : null;
            const formatted = date && !Number.isNaN(date.getTime()) ? [String(date.getDate()).padStart(2, '0'), String(date.getMonth() + 1).padStart(2, '0'), date.getFullYear()].join('/') : '';
            const fields = {
                soporteInferior: [this.finder, 'min_support_date'], soporteSuperior: [this.finder, 'max_support_date'],
                estabilizarInferior: [this.finder.profit_date, 0], estabilizarSuperior: [this.finder.profit_date, 1],
                maxHistoricoInferior: [this.finder.max_min_bar_date, 0], maxHistoricoSuperior: [this.finder.max_min_bar_date, 1]
            };
            const target = fields[field];
            if (!target || !target[0]) return;
            const current = target[0][target[1]];
            if ((current === '01/01/1970' ? '' : current) === formatted) return;
            this.$set(target[0], target[1], formatted);
            this._updateLastSearch2();
        },

        ...mapMutations(['setFinderFilters','setRechargeState']),
        _getValueFromSelect: function(value){
            const index = ['rentabilidadInferior', 'rentabilidadSuperior', 'numOndaInferior', 'numOndaSuperior', 'CFDsSelect'].indexOf(value[1]);
            if (index >= 0 && this.local_array_stocks_filters[index]) this.local_array_stocks_filters[index].value = value[0];
            if(this.show_criptos){
                //djiwhnfswnfwaf
            }else{
                if(value[1] == "rentabilidadInferior"){
                    if(value[0] == "< 35"){
                        this.finder["min_tae_lt"] = "";
                    }else{
                        this.finder["min_tae_lt"] = parseInt(value[0]);
                    }                    
                }
                if(value[1] == "rentabilidadSuperior"){
                    if(value[0] == "> 400"){
                        this.finder["max_tae_lt"] = "";
                    }
                    else{
                        this.finder["max_tae_lt"] = parseInt(value[0]);
                    }
                }

                if(value[1] == "numOndaInferior"){
                    if(value[0] == "All"){
                        this.finder.min_ona = "";
                    }else{
                        this.finder.min_ona = parseInt(value[0]);
                    }
                }
                if(value[1] == "numOndaSuperior"){
                    if(value[0] == "> 25"){
                        this.finder["max_ona"] = "";
                    }
                    else{
                        this.finder["max_ona"] = parseInt(value[0]);
                    }                                
                }

                if(value[1] == "CFDsSelect"){
                    if(value[0] == "No (Muestra todos los valores)"){
                        this.finder["extrad_cfds_direction"] = "0"
                    }else{
                        this.finder["extrad_cfds_direction"] = "1"
                    }
                }
                
                setTimeout(() => {
                    this._updateLastSearch2();
                }, 200);
            }

        },
        _dataToNewFormat: function(){
            var min_tae_lt_value;
            var max_tae_lt_value;
            //default value rentabilidad especifica
            if(this.finder["min_tae_lt"] == ""){
                min_tae_lt_value = "< 35"
            }
            else{
                min_tae_lt_value = this.finder["min_tae_lt"].toString();
            }

            if(this.finder["max_tae_lt"] == ""){
                max_tae_lt_value = "> 400"
            }else{
                max_tae_lt_value = this.finder["max_tae_lt"].toString();
            }
            //default value nºonda
            var min_onda;
            var max_onda;
            if(this.finder["min_ona"] == ""){
                min_onda = "All"
            }else{
                min_onda = this.finder["min_ona"].toString();
            }

            if(this.finder["max_ona"] == ""){
                max_onda = "> 25"
            }else{
                max_onda = this.finder["max_ona"].toString();
            }
            //default cfd
            var value_cfd;
            if(this.finder["extrad_cfds_direction"]== 0){
                value_cfd = "No (Muestra todos los valores)";
            }
            else{
                value_cfd = "Si (Muestra sólo CFDs habilitados)";
            }
            var select = [
                {
                    name : "R.especifica-li",
                    value: min_tae_lt_value,
                },
                {
                    name : "R.especifica-ls",
                    value: max_tae_lt_value,
                },
                {
                    name : "N.onda-li",
                    value: min_onda,
                },
                {
                    name : "N.onda-ls",
                    value: max_onda,
                },
                {
                    name : "CFD",
                    value: value_cfd,
                },
            ];
            if(this.finder["min_support_date"] == "01/01/1970"){
                this.datepicker_soporte_inferior = "";
            }else{
                this.datepicker_soporte_inferior = this.finder["min_support_date"];
            }

            if(this.finder["max_support_date"] == "01/01/1970"){
                this.datepicker_soporte_superior = "";
            }else{
                this.datepicker_soporte_superior = this.finder["max_support_date"];
            }

            if(this.finder["profit_date"][0] == "01/01/1970"){
                this.datepicker_estabilizar_inferior = "";
            }else{
                this.datepicker_estabilizar_inferior = this.finder["profit_date"][0];
            }

            if(this.finder["profit_date"][1] == "01/01/1970"){
                this.datepicker_estabilizar_superior = "";
            }else{
                this.datepicker_estabilizar_superior = this.finder["profit_date"][1];
            }

            if(this.finder["max_min_bar_date"][0] == "01/01/1970"){
                this.datepicker_maxHistorico_inferior = "";
            }else{
                this.datepicker_maxHistorico_inferior = this.finder["max_min_bar_date"][0];
            }

            if(this.finder["max_min_bar_date"][1] == "01/01/1970"){
                this.datepicker_maxHistorico_superior = "";
            }else{
                this.datepicker_maxHistorico_superior = this.finder["max_min_bar_date"][1];
            }

            this.local_array_stocks_filters = select;

        },
        _getFinderParameters: function(){
            this.finder = this._g_FinderFilters();
            this.finder_original = this._g_FinderFilters();
            this._dataToNewFormat();
            this._parseFromFinderToDate();
        },

        _updateLastSearch2: function(){
            this.setFinderFilters(this.finder);
            this.$emit("updateLastSearch", this.finder);
        },
    },
}
</script>

<style scoped>
    .filters-container:nth-child(2){
        content: '\A';
        white-space: pre;
    }
    .inline{
        display:inline-block;
    }
    h4{
        font-family: Open Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        /* identical to box height, or 171% */

        letter-spacing: 0.1px;

        /* 02. Secondary/400 */

        color: #626777;
        margin-top:0px;
    }
    .information-text{
        visibility: hidden;
        width: 120px;
        background-color: #151929;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
        margin-left: 2px;
    }
    .interrogant-container:hover .information-text{
        visibility: visible;
    }
    .row-one{
        display:relative;
    }
    .row-two{
        display:flex;
    }

    .datepicker-input{
        text-align:  center;
        font-size: 16px;
        margin-top: 10px;
        width:140px;
        height: 38px;
        border-radius: 5px;
        border-color: #aaadb7;
        margin-left: 8px;
    }

    .datepicker-input{
        border: 1px solid rgba(0, 0, 0, 0.1) !important;
        background-color: var(--color-background-background-casillas);
        height: 35px !important;
        margin-top: 0 !important;
    }

    .datepicker-input{
        border: 1px solid #c7c8cc !important;
        outline: none;
        margin: 0 !important;
        width: 150px !important;
        height: 50px !important;
    }

    .datepicker-input:hover, .datepicker-input:focus {
        border: 1px solid #343948 !important;
    }

    /*#my-helper-text{
        display: none;
    }*/

    @media (max-width: 900px){
        #filters-second-montante-inf-component, #filters-second-montante-sup-component, .inlined.second-mobile-select {
            margin-top: 15px;
            width: 150px;    
        }
    }
</style>
